export const getFoodState = payload => ({
    type: actionTypes.GET_FOOD_STATE,
    payload,
})

export const updateFoodState = payload => ({
    type: actionTypes.UPDATE_FOOD_STATE,
    payload,
})

export const retryOrder = payload => ({
    type: actionTypes.RETRY_ORDER,
    payload,
})

export const actionTypes = {
    SUBMIT_OREDER_SUCCESS: 'SUBMIT_OREDER_SUCCESS',
    GET_FOOD_STATE: 'GET_FOOD_STATE',
    UPDATE_FOOD_STATE: 'UPDATE_FOOD_STATE',
    RETRY_ORDER: 'RETRY_ORDER',
}
